// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"831":"ce2a4e73","996":"9e6ed75e"}[chunkId] + ".chunk.js";
};